var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-3"},[_c('cc-title',{staticClass:"mb-2 pl-5",staticStyle:{"margin-left":"-40px!important"},attrs:{"small":"","color":"pilot"}},[_vm._v(" Gear Loadout ")]),_c('cc-pilot-loadout',{attrs:{"pilot":_vm.pilot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }